window.gsap.registerPlugin(window.ScrollTrigger, window.ScrollToPlugin);

class ColourWaysShowcase extends HTMLElement {
  constructor() {
    super();

    this.count = this.dataset.productCount;
    this.images = this.querySelectorAll('li img');
    this.thumbnails = this.querySelectorAll('button');
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          document.body.classList.toggle('scroll_trigger_active_colourways', entry.isIntersecting);
        });
      },
      { threshold: 0 },
    );
  }

  connectedCallback() {
    this.observer.observe(this);

    document.addEventListener('DOMContentLoaded', () => {
      this.gsap();
      this.clickThumbnails();
    });
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  gsap() {
    const elementOffset = this.getBoundingClientRect().top + window.scrollY;
    const isBeforeStart = window.scrollY <= elementOffset;

    // Set first thumbnail active if before start, last thumbnail if after end
    this.thumbnails.forEach((thumbnail, index) => {
      const isActive = isBeforeStart ? index === 0 : index === this.images.length - 1;
      thumbnail.classList.toggle('active', isActive);
    });

    let tl = window.gsap.timeline({
      scrollTrigger: {
        id: this.id,
        trigger: this.querySelector('ul'),
        start: 'top 1px',
        end: `+=${this.count * this.images[0].offsetHeight + 1}`,
        preventOverlaps: true,
        fastScrollEnd: true,
        scrub: 0.25,
        pin: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        ignoreMobileResize: true,
        onUpdate: (self) => {
          this.updateActiveThumbnail(self);
        },
      },
      defaults: {
        ease: 'none',
      },
    });

    this.images.forEach((image, i) => {
      if (i) {
        tl.to(image, {
          clipPath: 'polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)',
        });
      }
    });
  }

  updateActiveThumbnail(self) {
    const start = self.start;
    const end = self.end;
    const totalDistance = end - start;
    const currentScroll = self.scroll();
    const totalImages = this.images.length;
    const progress = ((currentScroll - start) / totalDistance) * 100;

    let currentSection;

    if (totalImages === 2) {
      currentSection = progress < 50 ? 0 : 1;
    } else {
      const firstTransition = 25;
      const lastTransition = 75;

      if (progress < firstTransition) {
        currentSection = 0;
      } else if (progress >= lastTransition) {
        currentSection = totalImages - 1;
      } else {
        // For middle sections, divide the space between first and last transition
        const middleSpace = lastTransition - firstTransition;
        const sectionSize = middleSpace / (totalImages - 2);
        currentSection = Math.floor((progress - firstTransition) / sectionSize) + 1;
      }
    }

    // Ensure section doesn't exceed bounds
    currentSection = Math.min(currentSection, totalImages - 1);
    currentSection = Math.max(0, currentSection);

    // Update thumbnails
    this.thumbnails.forEach((thumbnail, index) => {
      const isActive = index === currentSection;
      thumbnail.classList.toggle('active', isActive);
    });
  }

  clickThumbnails() {
    this.thumbnails.forEach((button) => {
      button.addEventListener('click', (ev) => {
        const index = Array.from(button.parentNode.children).indexOf(button);
        const totalImages = this.images.length;
        const st = ScrollTrigger.getById(this.id);

        if (!st) {
          return;
        }

        let targetProgress;
        if (index === 0) {
          targetProgress = 0;
        } else if (index === totalImages - 1) {
          targetProgress = 1;
        } else {
          targetProgress = index / (totalImages - 1);
        }

        window.gsap.to(window, {
          scrollTo: st.start + (st.end - st.start) * targetProgress,
          duration: 0.75,
          ease: 'none',
        });
      });
    });
  }
}

customElements.define('colourways-showcase', ColourWaysShowcase);
